<template>
  <div class="test-container" :style="'background:' + $store.state.theme.themeSubColor">
    <div class="header" :style="{ paddingRight: fullScreen ? '100px' : '40px' }">
      <div class="bg" :style="'background:' + $store.state.theme.themeColor"></div>
      <p class="title">{{ examName }}</p>
      <div class="right-content">
        <div class="error-report zhiCustomBtn" :style="errorReportStyle" @click="zhiBtnClick" v-if="showUnusual">
          <icon-question class="icon-question"></icon-question>
          <span class="text">问题上报</span>
          <transition name="fade">
            <span class="count" v-show="hasUnReadMsg">
              <template v-if="unReadCount > 99">
                <i></i>
                <i></i>
                <i></i>
              </template>
              <template v-else>
                {{ unReadCount }}
              </template>
            </span>
          </transition>
          <transition name="translate-left">
            <div class="msg" v-show="!!unReadMsg">
              <span>{{ unReadMsg }}</span>
            </div>
          </transition>
        </div>
        <div class="user" v-if="(user || $store.state.account) && isDzkApp">
          <i :style="`background: url('${!user || user.avatar_url}') no-repeat center / cover;`"></i>
          <div class="info">
            <p>{{user.fullname || user.nickname || $store.state.account}}</p>
            <p class="id">ID：{{ user.id }}</p>
          </div>
        </div>
        <el-popover placement="left" width="340" class="oneMinuteTip" v-model="oneMintuteVisible" trigger="manual">
          <span class="oneMinuteText">
            <i style="color: #FAAD14;" class="el-icon-warning"></i>
            答题时间将在<span style="color: #E20303;">1</span>分钟后停止，系统将自动收卷</span>
          <div slot="reference" class="countdown">
            <span class="clock"></span>
            <span class="word">剩余时间</span>
            <span class="time" v-if="endTime">{{ endTime | formateTime(countdown) | timeFactory }}</span>
          </div>
        </el-popover>
        <button class="submit-btn flex-row-center" @click="submitPaper"><i class="icon-submit"></i>我要交卷</button>
      </div>
    </div>
    <div class="test-content" :style="{ paddingRight: fullScreen ? '0px' : '40px' }">
      <answer-content :question-list="questionList" :current-question="currentQuestion"
        :switchQuestionEnabled="switchQuestionEnabled" :total-finish="totalFinish" :total-score="examineeInfo.score"
        @changeQuestion="changeQuestion"></answer-content>
      <question-content ref="questionDom" :question-list="questionList" :question="currentQuestion" :is-first="isFirst"
        :is-last="isLast" :countdown="countdown" :end-time="endTime" :switchQuestionEnabled="switchQuestionEnabled"
        @changeQuesEnabled="changeQuesEnabled" @saveExplore="saveExplore" @showSaveLoading="showSaveLoading = true"
        @changeStyle="changeStyle" @openSlowTip="openSlowTip" @showLoginDialog="showLoginDialog"
        @changeQuestion="changeQuestion" @saveAnswer="saveAnswer" @submitPaper="submitPaper"></question-content>
      <div v-if="openAgoraMonitor || openCamera || openPhotoMonitor" class="monitor-wrap"
        :class="{ 'full-camera-monitor': fullScreen }" ref="monitorWrap" @mousedown="mouseDownHandler">
        <agora-rtc-monitor v-if="openAgoraMonitor" ref="agoraRtcMonitor" class="camera-monitor"
          :user-id="Number(user.id)" :option="agoraOption" :open-photo-monitor="openPhotoMonitor"
          @cameraError="cameraError" @photoReport="photoReport"></agora-rtc-monitor>
        <camera-monitor class="camera-monitor" :open-photo-monitor="openPhotoMonitor" @cameraError="cameraError"
          @photoReport="photoReport" v-if="(openCamera || openPhotoMonitor) && !openAgoraMonitor"></camera-monitor>
      </div>
    </div>
    <div class="loading-mask" v-show="showSaveLoading">
      <div class="loading-wrap">
        <looping-rhombuses-spinner :animation-duration="2500" :rhombus-size="30"
          :color="$store.state.theme.themeColor.split(';')[0]" class="loading-icon" />
        <p>答案保存中...</p>
      </div>
    </div>
    <modal width="410px" speed="fast" noOutClose :mask-no-click="submitStatus !== 0" :no-close="submitStatus !== 0"
      enter-active-class="fadeIn" leave-active-class="fadeOut" :show.sync="showSubmitStatus" class="submit-success">
      <div slot="content">
        <div class="tip-success">
          <i v-if="submitStatus !== 0" class="el-icon-success icon-success"></i>
          <i v-if="submitStatus === 0" class="el-icon-error icon-error"></i>
          {{ submitStatus === 0 ? '交卷失败' : '交卷成功' }}
        </div>
        <p class="tip-desc" v-if="submitStatus === 0">很遗憾试卷提交失败，请重新提交！</p>
        <p class="tip-desc" v-else>试卷提交成功，请尽快离开考场！</p>
        <div class="left-btn-wrap">
          <button class="confirm"
            :style="`background: ${$store.state.theme.buttonBackground} box-shadow: ${$store.state.theme.buttonShadow}`"
            @click="submitConfirm">退出考场</button>
          <span class="confirm-tip">3s后自动退出考场</span>
        </div>
      </div>
    </modal>
    <modal width="410px" speed="fast" noOutClose noFooter enter-active-class="fadeIn" leave-active-class="fadeOut"
      :show.sync="showConfirmSubmit" class="submit-tip">
      <div slot="content">
        <div class="tip">
          确认交卷？
        </div>
        <p class="tip-desc" v-if="!allDone">你还有<span class="total">{{ questionNum - totalFinish
            }}</span>道试题未作答完成呢<br />确定交卷吗？一旦交卷则不能再作答或修改答案</p>
        <p class="tip-desc" v-else>一旦交卷则不能再作答或修改答案</p>
        <div class="submit-btn-wrap">
          <button class="confirm"
            :style="`color: ${$store.state.theme.themeColor} border: 1px solid ${$store.state.theme.themeColor}`"
            @click="submitTest">确认交卷</button>
          <button class="continue"
            :style="`background: ${$store.state.theme.buttonBackground} box-shadow: ${$store.state.theme.buttonShadow}`"
            @click="cancel">继续答题</button>
        </div>
      </div>
    </modal>
    <modal width="410px" speed="fast" noHeader class="timeout-tip" noOutClose noClose maskNoClick
      enter-active-class="fadeIn" leave-active-class="fadeOut" :show.sync="showAutoSubmit">
      <div slot="content">
        <div class="tip flex-row-center">
          <p class="big-circle flex-row-center" :style="`background: ${$store.state.theme.lightThemeColor}`">
            <icon-funnel :style="`fill: ${$store.state.theme.themeColor}`"></icon-funnel>
          </p>
        </div>
        <p class="tip-desc">考试时间到，系统自动收卷中……</p>
      </div>
    </modal>
    <modal width="410px" speed="fast" class="timeout-tip" noOutClose noFooter noHeader maskNoClick
      enter-active-class="fadeIn" leave-active-class="fadeOut" :show.sync="earlyTip">
      <div slot="content">
        <div class="tip flex-row-center">
          <p class="big-circle flex-row-center" style="background: #FADBD7;">
            <span class="small-circle flex-row-center" style="background: #E84B39;"><icon-sigh
                class="icon-sigh"></icon-sigh></span>
          </p>
        </div>
        <p class="tip-early red">{{ (testInfo.start_time + earlySubmitMinute * 60 * 1000) | date('m月d日 H:i') }} 之前不允许交卷
        </p>
        <p class="tip-early">请考生仔细检查，遵照考试规定时间提交试卷。 </p>
        <div class="modal-btn">
          <button class="continue"
            :style="`background: ${$store.state.theme.buttonBackground} box-shadow: ${$store.state.theme.buttonShadow}`"
            @click="earlyTip = false">知道了</button>
        </div>
      </div>
    </modal>
    <modal width="410px" speed="fast" class="submit-tip" maskNoClick noOutClose noFooter noHeader
      enter-active-class="fadeIn" leave-active-class="fadeOut" :show="showBackTip">
      <div slot="content">
        <div class="tip">
          <p class="big-circle flex-row-center" style="background: #FADBD7;">
            <span class="small-circle flex-row-center" style="background: #E84B39;"><icon-sigh
                class="icon-sigh"></icon-sigh></span>
          </p>
        </div>
        <p class="tip-desc">是否后退，后退会导致退出考试。</p>
        <div class="btn-wrap" style="justify-content: center;">
          <button class="cancel" @click="backPrev(true)">退出</button>
          <button class="continue"
            :style="`background: ${$store.state.theme.buttonBackground} box-shadow: ${$store.state.theme.buttonShadow}`"
            @click="backPrev()">取消</button>
        </div>
      </div>
    </modal>
    <div v-if="showLoading" class="show-loading-icon">
      <looping-rhombuses-spinner :animation-duration="2500" :rhombus-size="30"
        :color="$store.state.theme.themeColor.split(';')[0]" />
    </div>
    <score :show.sync="scoreShow" v-if="scoreShow"></score>
    <page-hidden-tip v-if="showPageHiddenTip" :no-record-page-hidden="noRecordPageHidden"
      :current-question="currentQuestion" :test-info="testInfo"></page-hidden-tip>
    <test-camera-error-modal v-show="showCameraErrorTip" @close="showCameraErrorTip = false"></test-camera-error-modal>
    <slow-network-tip v-if="showSlowTip" :type="slowTipType" @close="showSlowTip = false"></slow-network-tip>
    <modal width="410px" speed="fast" class="submit-tip" maskNoClick noOutClose noFooter noHeader
      enter-active-class="fadeIn" leave-active-class="fadeOut" :show="showForceExit">
      <div slot="content">
        <div class="tip">
          提示
        </div>
        <p class="tip-desc">当前考试因故已被管理员终止，系统将在3秒内退出，请密切关注进一步通知</p>
        <div class="btn-wrap" style="justify-content: center;">
          <button class="continue"
            :style="`background: ${$store.state.theme.buttonBackground} box-shadow: ${$store.state.theme.buttonShadow}`"
            @click="exitExam">退出考试</button>
        </div>
      </div>
    </modal>
    <login-dialog :visible="loginDialogVisible" :show-close="false" @close="hideLoginDialog"
      @success="onSuccessLogin"></login-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import AnswerContent from './AnswerContent'
import QuestionContent from './QuestionContent'
import Score from './Score'
import { Popover } from 'element-ui'
import Modal from '@/components/Modal'
import LoopingRhombusesSpinner from 'epic-spinners/src/components/lib/LoopingRhombusesSpinner'
import { get, post, kittenGet } from '@/utils/ajax'
import { isInDzkApp } from '@/utils'
import { mapMutations, mapState } from 'vuex'
import PageHiddenTip from './PageHiddenTip'
import IconFunnel from '@/assets/svg/icon-funnel.svg'
import IconSigh from '@/assets/svg/icon-sigh.svg'
import IconQuestion from '@/assets/svg/icon-question.svg'
import AgoraRtcMonitor from './AgoraRtcMonitor'
import CameraMonitor from './CameraMonitor'
import TestCameraErrorModal from '@/views/components/TestCameraErrorModal'
import SlowNetworkTip from './SlowNetworkTip'
import LoginDialog from '@/components/LoginDialog'
import * as Sentry from '@sentry/browser'

export default {
  components: {
    AnswerContent,
    QuestionContent,
    Modal,
    LoopingRhombusesSpinner,
    Score,
    PageHiddenTip,
    IconSigh,
    IconFunnel,
    IconQuestion,
    AgoraRtcMonitor,
    CameraMonitor,
    TestCameraErrorModal,
    ElPopover: Popover,
    SlowNetworkTip,
    LoginDialog
  },
  props: {
    showBackTip: Boolean,
    backPrev: Function
  },
  data() {
    return {
      earlyTip: false, // 最早交卷限制弹窗
      endTime: 0, // 考试结束时间
      originTime: 0, // 远程时间
      countdown: 0, // 远程时间倒计时时间戳
      testTime: 0, // 时间记录：1 距离倒计时1分钟 2 结束
      showLoading: false, // 题目加载loading
      showLoadingTime: 0, // 题目加载loading开始时间
      showSaveLoading: false, // 题目保存loading
      showSaveLoadingTime: 0, // 题目保存loading开始时间
      scoreShow: false,
      date: '',
      questionList: [],
      currentQuestion: {},
      testInfo: {},
      isFirst: false,
      isLast: false,
      allDone: false,
      showAutoSubmit: false, // 自动交卷中弹窗
      showConfirmSubmit: false, // 确认交卷弹窗
      submitStatus: 2, // 0-提交失败 1-提交成功
      showSubmitStatus: false, // 交卷结果弹窗
      examName: '',
      submitTimer: null,
      showPageHiddenTip: false, // 展示切屏警告
      pageHiddenCount: 0,
      noRecordPageHidden: false,
      examConfig: {},
      showUnusual: false, // 问题上报按钮
      openAgoraMonitor: false,
      openCamera: false,
      openPhotoMonitor: false,
      openExamNotice: false,
      agoraOption: {},
      fullScreen: false,
      showCameraErrorTip: false,
      earlySubmitMinute: 0,
      msgTimer: null,
      hasUnReadMsg: false,
      unReadMsg: '', // 问题上报未读消息
      unReadCount: 0, // 问题上报未读消息数量
      timeDiff: 0, // 服务器与本地时间差
      diffX: 0,
      diffY: 0,
      draging: false,
      showSlowTip: false,
      slowTipType: 'loadQues',
      showForceExit: false, // 强制退出弹窗
      switchQuestionEnabled: true,
      firstCheck: false, // 第一次检查
      papersId: 0, // 试卷Id
      startAt: 0, // 每到题目的开始时间
      endAt: 0, // 结束时间
      oneMintuteVisible: false, // 最后一分钟提示
      confirmTime: null,
      recordExamineeAnswerDetail: true,
      loginDialogVisible: false, // 显示登录弹窗
      isDzkApp: isInDzkApp() // 是否在定制课app里
    }
  },
  computed: {
    ...mapState(['weishengRoute', 'eduteacherRoute']),
    user() {
      return this.$store.state.user
    },
    examineeInfo() {
      return this.$store.state.examineeInfo
    },
    errorReportStyle() {
      const { themeColor } = this.$store.state.theme
      return {
        color: themeColor.replace(';', ''),
        fill: themeColor.replace(';', '')
      }
    },
    // 题目总数
    questionNum() {
      return this.questionList.length
    },
    // 完成总数
    totalFinish() {
      let total = 0
      this.questionList.forEach((el) => {
        if (el.done) {
          total++
        }
      })
      return total
    }
  },
  watch: {
    testTime(n) {
      // 倒计时1分钟提醒
      if (n === 1) {
        this.openOneMinute() // 改成倒计时1分钟
      }
      // 倒计时结束自动交卷（慎用）
      if (n === 2) {
        this.showAutoSubmit = true
        // 展示自动收卷
        this.saveCurAnswerAndSubmit(2)
      }
    }
  },
  filters: {
    // 页面倒计时
    formateTime(value, countdown) {
      const time = value - countdown
      return time
    },
    // 倒计时格式化
    timeFactory(timestamp) {
      timestamp = timestamp / 1000
      if (timestamp <= 0) {
        return '00 : 00 : 00'
      }
      let h = Math.floor(timestamp / 3600)
      let m = Math.floor(timestamp / 60 % 60)
      let s = Math.floor(timestamp % 60)
      h = h < 10 ? 0 + '' + h : h
      m = m < 10 ? 0 + '' + m : m
      s = s < 10 ? 0 + '' + s : s
      return h + ' : ' + m + ' : ' + s
    }
  },
  methods: {
    ...mapMutations({
      setExaminee: 'SET_EXAMINEE_INFO'
    }),
    // 展示倒计时
    openOneMinute() {
      this.oneMintuteVisible = true
      setTimeout(() => {
        this.oneMintuteVisible = false
      }, 10000)
    },
    // 记录当下时间
    recordNowTime(isStart = true) {
      if (isStart) {
        this.startAt = moment().unix() * 1000
      } else {
        this.endAt = moment().unix() * 1000
      }
    },
    // 提交答卷
    async submitPaper() {
      this.showSaveLoading = true
      // 如果不是操作题，做保存动作
      if (![10, 11, 12].includes(this.currentQuestion.typeId)) {
        await this.saveCurrentAnswer()
      }
      this.earlyControl()
    },
    // 2.获取远程时间，开始倒计时，时间3分钟提醒，时间结束交卷退出
    async getTime() {
      const time = await this.setTimeDiff()
      this.countdown = time
      // 初始化一次
      this.showLoadingTime = time
      this.originTime = time
      const time1 = +Date.now()
      const diff = this.timeDiff
      this.timer = setInterval(() => {
        const time2 = +Date.now()
        const accuracy = time2 - time1 + this.timeDiff - diff
        this.startTime(accuracy)
      }, 1000)
    },
    // 时间操作
    async startTime(accuracy) {
      this.countdown = this.originTime + accuracy
      // 考试剩余时间，可以为负数
      if (!this.endTime || this.endTime === 0) {
        return
      }
      const time = this.endTime - this.countdown
      // 一秒的差额下变动
      if (time < 1 * 60000 && time > (1 * 60000 - 1000)) {
        this.testTime = 1
      } else if (time <= 0) {
        // 交卷之前校验本地与服务器时间
        const serverTime = await this.setTimeDiff()
        if (this.endTime - serverTime <= 0) {
          this.testTime = 2
        }
      }

      // loading图出现时间不超过20秒
      if (!this.showSaveLoading) { // 答案保存loading
        this.showSaveLoadingTime = this.countdown
      } else if (this.countdown - this.showSaveLoadingTime > 1000 * 20) {
        this.openSlowTip('saveSlow')
        this.showSaveLoading = false
      }
      // loading图出现时间不超过20秒
      if (!this.showLoading) { // 题目加载loading
        this.showLoadingTime = this.countdown
      } else if (this.countdown - this.showLoadingTime > 1000 * 20) {
        this.openSlowTip('loadQues')
        this.closeShowLoading()
      }

      // 60秒执行一次，获取后台考试配置
      if (parseInt(accuracy / 1000) % 60 === 0) {
        this.check(localStorage.examId)
        // 获取考试结束时间
        this.checkEndTime()
        this.setTimeDiff()
      }
    },
    // 获取服务器时间
    async getSeverTime() {
      const data = await get('/home/common/times')
      return data
    },
    // 设置本地与服务器时间差
    async setTimeDiff() {
      const serverTime = await this.getSeverTime()
      this.timeDiff = serverTime - Date.now()
      return serverTime
    },
    closeShowLoading() {
      this.showLoading = false
      this.showLoadingTime = this.countdown
    },
    // 1.获取考试信息
    async getTestInfo() {
      try {
        this.testInfo = await get(`/home/exams/${localStorage.examId}/examinees/${localStorage.user_id}/profile`, null, { ignoreMsg: true })
        // 4-8 不可答题
        if (this.testInfo.examinee_status === 0 || this.testInfo.examinee_status >= 4) {
          this.$message.info('考试未开始或已结束')
          this.$router.push({ name: 'list', params: { noBackTip: true } })
        } else {
          this.testInfo.exam_id = localStorage.examId
          this.setExaminee(this.testInfo)
          this.getPapersId()
          this.initTest()
        }
      } catch (e) {
        console.log(e)
        this.$message.info('考试未开始或已结束')
        this.$router.push({ name: 'list', params: { noBackTip: true } })
      }
    },
    // 开始考试获取各种数据
    async initTest() {
      this.getTime()
      this.getTestProcess()
      await this.check(localStorage.examId)
      if (this.showUnusual) { // 若问题上报开启，加载智齿
        this.loadZhiChiScript()
      }
      this.$store.dispatch('setMonitorReport', { type: 4 }) // 上报考试监控埋点，开始答题
    },
    beforeunloadFun(e) {
      e.returnValue = true
      this.noRecordPageHidden = true
    },
    // 2.获取考卷信息
    async getTestProcess() {
      const data = await get(`/home/edu/examinees/${this.examineeInfo.exam_id}/${this.examineeInfo.examinee_id}/progress`)
      this.examName = this.examName ? this.examName : data.examName // 考试名称
      this.endTime = data.endTime // 结束时间
      this.questionList = data.questionList // 题目列表

      // 读取缓存的当前答题信息
      const questionId = localStorage.getItem('currentQuestionId') || ''
      const userId = localStorage.getItem('user_id') || ''
      const examId = localStorage.getItem('examId') || ''

      // 如果一致就加载缓存的题目ID详情
      if (+questionId && +examId === +this.examineeInfo.exam_id && +userId === this.user.id) {
        this.getQuestionInfo(+questionId)
      } else {
        this.getQuestionInfo(data.questionList[0].questionId)
      }
    },
    // 3.当前题目详情区（题型，题目，选项，答案）获取题目信息延长loading
    async getQuestionInfo(id) {
      this.recordNowTime() // 初始化记录时间
      if (!id) return
      try {
        this.showLoading = true
        this.currentQuestion = await get(`/home/edu/questions/${this.examineeInfo.exam_id}/${id}/${this.examineeInfo.examinee_id}`, {}, { ignoreMsg: true })
        this.showLoading = false
        // 隐藏上一题
        this.isFirst = id === this.questionList[0].questionId
        // 隐藏下一题
        this.isLast = id === this.questionList[this.questionList.length - 1].questionId
      } catch (e) {
        this.showLoading = false
        this.handleError(e)
      }
    },
    cancel() {
      this.showConfirmSubmit = false
    },
    async checkTestFinish() {
      try {
        const { allDone } = await get(`/home/edu/examinees/check/${localStorage.examId}/${this.testInfo.examinee_id}`, {}, { ignoreMsg: true })
        this.allDone = allDone
        this.showSaveLoading = false
        this.showConfirmSubmit = true
      } catch (e) {
        this.handleError(e)
      }
    },
    // 最早交卷控制
    async earlyControl() {
      this.showSaveLoading = true
      // 设置了最早交卷且没超过最早交卷时间就提示不能交卷
      const time = await get('/home/common/times')
      if (this.earlySubmitMinute && time - this.testInfo.start_time <= this.earlySubmitMinute * 60 * 1000) {
        this.earlyTip = true
      } else {
        await this.checkTestFinish()
      }
    },
    // 保存当前问题答案 type 1-正常交卷 2-系统交卷 3-强制交卷
    async saveCurAnswerAndSubmit(type) {
      // 自动收卷要特殊处理主观题，考生打开了编辑器，那时收卷要保存题目
      if (this.$refs.questionDom.isFullScreen) {
        // 涉及异步 message 事件
        this.$refs.questionDom.outFullScreen()
      } else {
        await this.saveCurrentAnswer()
      }
      await this.submitTest(type)
    },
    // 保存当前答案
    async saveCurrentAnswer() {
      const currentId = this.currentQuestion.questionId
      const answer = this.$refs.questionDom.answerMap[currentId]
      if (answer) {
        await this.saveAnswer({
          which: 'saveQuestion',
          answer,
          currentId
        })
      }
    },
    // 切换题目（点击题目,点击上/下一题）
    changeQuestion(data) {
      let id = data.currentId
      const currentIndex = this.questionList.findIndex(el => el.questionId === data.currentId)
      switch (data.which) {
        case 'selectQuestion':
          id = data.currentId
          break
        case 'prevQuestion':
          id = this.questionList[currentIndex - 1] && this.questionList[currentIndex - 1].questionId
          break
        case 'nextQuestion':
          id = this.questionList[currentIndex + 1] && this.questionList[currentIndex + 1].questionId
          break
      }
      // 拉取题目详情
      this.getQuestionInfo(id)
    },
    // 保存答案
    async saveAnswer(data) {
      let steps = -1
      if (!data.answer) {
        this.showSaveLoading = false
        return
      }
      if (typeof data.answer === 'string') {
        const len = data.answer.split('\n').length
        steps = len === 0 ? -1 : len
      }

      let currentQuestion

      // 有可能收到保存消息的时候切题了，所以加入ID判断
      if (data.currentId === this.currentQuestion.questionId) {
        currentQuestion = this.currentQuestion
      } else {
        currentQuestion = this.questionList.find(el => el.questionId === data.currentId)
      }

      const { questionId, questionNo, typeId } = currentQuestion
      let answer = data.answer
      if (typeId === 2) {
        answer = data.answer.join(',')
      } else if (typeId === 11) {
        answer = data.answer.url
      }
      const params = {
        examId: this.examineeInfo.exam_id,
        examineeId: this.examineeInfo.examinee_id,
        questionId,
        questionNo,
        typeId,
        answer,
        workId: null,
        steps: data.steps || steps
      }
      // 判断是否是kitten题，进行块数请求
      if (data.which === 'saveKitten') {
        const bcmUrl = data.answer.url
        const kittenBlock = await this.getKittenBlock(bcmUrl)
        params.steps = kittenBlock
      }
      // 判断是否是闯关题，增加而外参数
      if (data.which === 'saveExplore') {
        params.levelConquerDetail = data.levelConquerDetail
      }
      try {
        await post('/home/edu/examineeExamRecode/answer', params, { ignoreMsg: true })
        // 是否有成功回调，有就调用
        if (data.successCallback) {
          data.successCallback()
        }
        this.showSaveLoading = false
        this.setQuestionDone(currentQuestion.questionId)

        if (['saveKitten', 'savePython', 'saveScratch', 'saveCplusplus', 'savePythonOj'].includes(data.which)) {
          this.$message.success('保存成功')
        }
      } catch (e) {
        // 是否有成功回调，有就调用
        if (data.failCallback) {
          data.failCallback()
        }
        this.handleError(e)
      }
    },
    // 保存题目的花费时间
    // async saveTimeCost(data) {
    //   const { questionId, questionNo } = this.currentQuestion
    //   const _finishTime = (this.endAt - this.startAt) / 1000
    //   const params = {
    //     examId: Number(this.examineeInfo.exam_id),
    //     examineeId: this.examineeInfo.examinee_id,
    //     paperId: this.papersId,
    //     questionId,
    //     questionNo,
    //     startAt: this.startAt,
    //     endAt: this.endAt,
    //     timeCost: data.finishTime ? data.finishTime : _finishTime
    //   }
    //   try {
    //     await post('/home/edu/examineeExamRecode/answer/details', params, { ignoreMsg: true })
    //   } catch (e) {
    //     this.handleError(e)
    //   }
    // },
    // 保存操作题的额外信息
    async saveExplore(data) {
      this.recordNowTime(false) // 停止记录时间
      const finishTime = (this.endAt - this.startAt) / 1000
      const levelConquerDetail = {
        startAt: this.startAt,
        endAt: this.endAt,
        timeCost: data.finishTime ? data.finishTime : finishTime,
        paperId: this.papersId,
        result: 1,
        score: -1
      }
      this.recordNowTime()
      this.saveAnswer({ ...data, levelConquerDetail })
    },
    // 获取kitten题目的块数
    async getKittenBlock(bcm_url) {
      try {
        const data = await kittenGet('/data-center/correction/block_nums', { bcm_url }, { ignoreMsg: true })
        return data
      } catch (e) {
        this.handleError(e)
      }
    },
    // 获取试卷id
    async getPapersId() {
      const examId = this.examineeInfo.exam_id
      const papersData = await get(`/home/exams/${examId}/papers`, { ignoreMsg: true })
      this.papersId = papersData
    },
    // 设置题目状态为完成
    setQuestionDone(currentId) {
      const currentIndex = this.questionList.findIndex(el => el.questionId === currentId)
      const question = this.questionList[currentIndex]
      question.done = true
      this.questionList.splice(currentIndex, 1, question)
    },
    // 提交答卷 type 1-正常交卷 2-系统交卷 3-强制交卷
    async submitTest(type) {
      if (type !== 3) {
        // 提交答卷前检测是否延长考试
        const hasDelayTime = await this.checkEndTime()
        if (hasDelayTime) {
          return
        }
      }

      const func = await this.funcAPI()
      if (!func) {
        return true
      } else {
        try {
          clearInterval(this.timer)
          await post(`/home/edu/examinees/end/${this.examineeInfo.exam_id}/${this.examineeInfo.examinee_id}`)
          // 清除答题进度
          localStorage.removeItem('currentQuestionId')
          if (type !== 3) {
            this.showAutoSubmit = false
            this.showConfirmSubmit = false
            this.submitStatus = 1
            if (this.testInfo.show_grade === 1) {
              this.scoreShow = true
            } else {
              this.showSubmitStatus = true
              this.confirmTime = setTimeout(() => {
                this.submitConfirm()
              }, 3000)
            }
          }
        } catch (e) {
          this.submitStatus = 0
          this.showSubmitStatus = true
        }
      }
    },
    async funcAPI() {
      let isOk = true
      if (this.$route.path.split('/')[1].indexOf(this.weishengRoute) >= 0) {
        try {
          const res = await post('/home/outsize/weisheng/users', { uniqId: localStorage.UniqId })
          isOk = res.data.isOk
          if (!isOk) {
            this.$message(res.error.message || '威盛登录态失效,请重新登录！')
            return false
          } else {
            return true
          }
        } catch (error) {
          // console.log(error)
          this.$message('威盛登录态失效,请重新登录！')
          return false
        }
      }
      if (this.$route.path.split('/')[1].indexOf(this.eduteacherRoute) >= 0) {
        try {
          const info = JSON.parse(localStorage.eduTeacher)
          if (!info['exam' + localStorage.examId]) {
            this.$message('解析失败，请由未来教室跳转进入考试')
            return false
          }
          const infoItem = info['exam' + localStorage.examId]
          if (infoItem.userId.toString() !== localStorage.user_id.toString()) {
            this.$message('解析失败，请勿切换账号，请由未来教室跳转进入考试')
            return false
          }
          return true
        } catch (error) {
          this.$message('解析失败，请由未来教室跳转进入考试')
          localStorage.removeItem('eduTeacher')
          return false
        }
      }
      return true
    },
    async submitConfirm() {
      // 加逻辑
      clearTimeout(this.confirmTime)
      this.showSubmitStatus = false
      this.handleReturnRoute()
    },
    // 获取后台考试配置开关（身份核验，反作弊，问题上报，切屏监控等）
    async check(examId) {
      const { exam_config, early_submit_minute } = await get(`/home/exams/check/${examId}`)
      exam_config.forEach(item => {
        const label = item.label.split('#')[1]
        this.examConfig[label] = item.actual_value
      })
      this.showUnusual = this.examConfig['unusual_report'] === '1'
      this.openCamera = this.examConfig['float_video_window'] === '1'
      this.openAgoraMonitor = this.examConfig['keep_video_record'] === '1'
      if (this.openAgoraMonitor && !this.agoraOption.uid) { // 获取声网录制token
        this.getAgoraToken()
      }
      this.openPhotoMonitor = this.examConfig['ai_check'] === '1'
      this.showPageHiddenTip = this.examConfig['switch_screen'] === '1'
      this.recordExamineeAnswerDetail = this.examConfig['record_examinee_answer_detail'] === '1'
      this.earlySubmitMinute = early_submit_minute
      if (!this.firstCheck) { // 首次配置修改赋值
        // 兼容老的考试配置
        const sqe = this.examConfig['switch_question_enabled']
        this.switchQuestionEnabled = sqe ? sqe === '1' : true
        this.firstCheck = true
      }
    },
    // 是否允许进行切题操作
    changeQuesEnabled(flag = true) {
      const sqe = this.examConfig['switch_question_enabled']
      this.switchQuestionEnabled = !flag ? flag : sqe ? sqe === '1' : true
    },
    // 摄像头打开失败
    cameraError(type) {
      console.log('openCameraError', type)
      this.showCameraErrorTip = true
    },
    // 获取声网录制token
    async getAgoraToken() {
      const params = {
        userId: this.user.id,
        examId: localStorage.examId
      }
      const data = await get(`/home/ai-invigilate/agora-token`, params)
      this.agoraOption = Object.assign({}, data)
    },
    // 打开操做题全屏修改右侧布局样式
    changeStyle(flag) {
      this.fullScreen = flag
    },
    // 拍照上报，监控异常行为
    async photoReport(url) {
      const params = {
        currentPhoto: url,
        deviceId: this.$store.state.browserFinger,
        examId: localStorage.examId,
        timestamp: Date.now(),
        userId: this.user.id
      }
      const { normal, dystropyType } = await post(`/home/ai-invigilate/invigilate-note`, params)
      if (!normal) { // 行为不正常
        let tip = ''
        switch (dystropyType) {
          case 2:
            tip = '监测到离开摄像头'
            // tip = '监考系统检测到您已离开摄像头，该行为涉嫌严重违反在线考试规则，考试结束后将进行人工核查确认您是否违规，请先继续完成考试。'
            break
          case 3:
            tip = '监测到多人'
            // tip = '监考系统检测到有多人出现在摄像头前，该行为涉嫌严重违反在线考试规则，考试结束后将进行人工核查确认您是否违规，请先继续完成考试。'
            break
          case 4:
            tip = '监测到非本人'
            // tip = '监考系统检测到非本人出现在摄像头前，该行为涉嫌作弊，已被监考系统上报，考试结束后将进行人工核查确认您是否作弊，请先继续完成考试。'
            break
        }
        if (tip) {
          this.$message({
            type: 'warning',
            message: tip,
            duration: 6000
          })
        }
      }
    },
    loadZhiChiScript() {
      const accountId = this.examConfig['zhichi_account_id']
      const pageId = this.examConfig['zhichi_access_page_id']
      const script = document.createElement('script')
      script.async = true
      script.id = 'zhichiScript'
      script.className = 'zhiCustomBtn'
      script.src = `https://www.sobot.com/chat/frame/v2/entrance.js?sysnum=${accountId}&channelid=${pageId}`
      document.body.appendChild(script)
      window['zc'] = function () {
        window.cbk = window.cbk || []
        window.cbk.push(arguments)
      }
      window.zc('config', {
        custom: true, // 自定义btn
        partnerid: this.user.id // 用户ID
      })
      // 获取未读取消息
      window.zc('receive_message', ([{ msg }]) => {
        clearTimeout(this.msgTimer)
        this.hasUnReadMsg = true
        this.unReadCount++
        this.unReadMsg = msg
        this.msgTimer = setTimeout(() => {
          this.unReadMsg = ''
        }, 5000)
      })
    },
    zhiBtnClick() {
      this.hasUnReadMsg = false
      this.msgTimer = setTimeout(() => {
        this.unReadMsg = ''
        this.unReadCount = 0
      }, 100)
    },
    mouseDownHandler(e) {
      const { offsetLeft, offsetTop } = this.$refs.monitorWrap
      this.diffX = e.clientX - offsetLeft
      this.diffY = e.clientY - offsetTop
      this.draging = true
    },
    mouseUpHandler(e) {
      this.draging = false
    },
    mouseMoveHandler(e) {
      if (this.draging) {
        const { clientWidth, clientHeight } = document.body
        const { offsetWidth, offsetHeight } = this.$refs.monitorWrap
        const left = Math.min(clientWidth - offsetWidth, Math.max(0, e.clientX - this.diffX))
        const top = Math.min(clientHeight - offsetHeight, Math.max(0, e.clientY - this.diffY))
        this.$refs.monitorWrap.style.left = `${left}px`
        this.$refs.monitorWrap.style.top = `${top}px`
      }
    },
    openSlowTip(type) {
      this.slowTipType = type
      this.showSlowTip = true
    },
    async handleError(e) {
      if (e.error_code === 20612002) { // 考试时间到点自动收卷 or 单个考生强制收卷
        // 关闭监控视频流
        const monitor = this.$refs.agoraRtcMonitor
        if (monitor) {
          await monitor.leave()
          await monitor.closeTimer()
        }
        this.submitConfirm()
      } else if (e.error_code === 20612004) { // 后台整场终止
        this.forceExitExam()
      } else if (e.error_code === 20612005) { // 换考
        this.$message({
          type: 'warning',
          message: '考生对应考试已换考',
          onClose: this.exitExam
        })
      } else if (e.error_code === 20601005) { // 登录态失效
        this.showLoginDialog()
        Sentry.captureEvent({
          message: '登录态中途失效，显示登录弹窗'
        })
      } else {
        this.$message.error(`${e.error_msg || '未知错误'}`)
      }
    },
    // 获取考试结束时间
    async checkEndTime() {
      let hasDelayTime = false
      try {
        const { endTime } = await get(`/home/edu/examinees/${this.examineeInfo.exam_id}/${this.examineeInfo.examinee_id}/progress`, {}, { ignoreMsg: true })
        if (endTime && this.endTime < endTime) {
          const diff = parseInt((endTime - this.endTime) / 1000 / 60)
          if (diff !== 0) {
            this.endTime = endTime
            this.showAutoSubmit = false
            this.showSubmitStatus = false
            this.testTime = 0
            hasDelayTime = true
            this.$message.warning(`当前考试因故延长时间${diff}分钟`)
          }
        }
      } catch (e) {
        this.handleError(e)
      }
      return hasDelayTime
    },
    // 显示强制退出考试弹窗
    forceExitExam() {
      if (this.submitTimer) {
        return
      }
      this.showForceExit = true
      this.submitTimer = setTimeout(() => {
        this.exitExam()
      }, 3000)
    },
    // 退出考试
    async exitExam() {
      clearTimeout(this.submitTimer)
      this.showForceExit = false
      await this.saveCurAnswerAndSubmit(3)
      this.handleReturnRoute()
    },
    // 交卷后返回上一页面
    async handleReturnRoute() {
      const redirection = await get(`/home/exams/${this.examineeInfo.exam_id}/regions`)
      if (redirection.over_link === 1) {
        await this.$store.dispatch('logout')
        localStorage.clear()
        this.$router.replace({ name: 'login', params: { noBackTip: true } })
      } else if (redirection.over_link === 3 && !!redirection.overLinkUrl) {
        // 配置了第三方跳转链接
        window.location.href = redirection.overLinkUrl
      } else {
        this.$router.replace({ name: 'list', params: { noBackTip: true } })
      }
    },
    // 显示登录弹窗
    showLoginDialog() {
      this.loginDialogVisible = true
    },
    hideLoginDialog() {
      this.loginDialogVisible = false
    },
    // 弹窗登录成功后
    onSuccessLogin() {
      this.loginDialogVisible = false
      Sentry.captureEvent({
        message: '登录态中途失效，弹出登录框'
      })
    }
  },
  mounted() {
    this.$store.dispatch('getQiniuToken')
    this.getTestInfo()
    // 监听监视器拖动
    document.addEventListener('mousemove', this.mouseMoveHandler)
    document.addEventListener('mouseup', this.mouseUpHandler)
    window.addEventListener('beforeunload', this.beforeunloadFun) // 监听页面刷新或关闭标签页事件
  },
  destroyed() {
    clearInterval(this.timer)
    clearTimeout(this.submitTimer)
    clearTimeout(this.msgTimer)
    document.removeEventListener('mousemove', this.mouseMoveHandler)
    document.removeEventListener('mouseup', this.mouseUpHandler)
    window.removeEventListener('beforeunload', this.beforeunloadFun)
  }
}
</script>
<style>
#zc__bubble_container {
  display: none;
}

.oneMinuteText {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  letter-spacing: 1px;
}
</style>
<style lang="scss" scoped>
.submit-btn {
  width: 180px;
  height: 48px;
  border-radius: 4px;
  background: linear-gradient(270deg, rgba(255, 167, 33, 1) 0%, rgba(255, 202, 33, 1) 100%);
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  margin: 36px 0 0 20px;

  &:hover {
    opacity: .8;
  }

  .icon-submit {
    display: inline-block;
    width: 28px;
    height: 28px;
    background: url("~@/assets/images/icon-submit.png") center / cover no-repeat;
    margin-right: 5px;
    margin-top: 2px;
  }
}

.monitor-wrap {
  position: fixed;
  right: 80px;
  bottom: 107px;
  width: 240px;
  height: 160px;
  cursor: pointer;
  z-index: 6;

  /deep/ .camera-monitor {
    position: initial;
    right: initial;
    bottom: initial;
  }
}

.translate-left-enter-active {
  transition: all ease-in-out 0.5s;
}

.translate-left-leave-active {
  transition: all ease 0.2s;
}

.translate-left-enter-to,
.translate-left-leave {
  max-width: 456px;
}

.translate-left-enter,
.translate-left-leave-to {
  max-width: 60px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.show-loading-icon {
  width: 100%;
  height: calc(100% - 100px);
  top: 100px;
  left: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  background: rgba(0, 0, 0, 0.4);
}

.test-container {
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 1000px;
  display: flex;
  flex-direction: column;
}

.header {
  width: 100%;
  height: 257px;
  min-height: 257px;
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 0 40px 0;
  z-index: 1;
  overflow: hidden;

  .bg {
    position: absolute;
    width: 18000px;
    height: 18000px;
    border-radius: 50%;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: -1;
  }

  .title {
    font-size: 30px;
    font-weight: 500;
    color: #fff;
    line-height: 42px;
    padding-top: 45px;
  }

  .right-content {
    display: flex;
  }

  .error-report::after,
  .error-report .msg::after {
    display: block;
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    border-style: solid;
    border-width: 15px;
    transform: rotate(90deg);
    border-radius: 11px;
  }

  .error-report {
    position: relative;
    width: 132px;
    height: 40px;
    padding: 0 15px;
    margin: 36px 28px 0 0;
    font-size: 16px;
    color: $themeColor;
    display: flex;
    align-items: center;
    cursor: pointer;
    background-color: #fff;
    box-shadow: 0 2px 6px 0 rgba(156, 156, 156, 0.5);
    border-radius: 30px;

    &::after {
      border-color: transparent transparent transparent #fff;
      bottom: -13px;
      left: 18px;
    }

    .icon-question {
      fill: inherit;
      z-index: 2;
    }

    .text {
      margin-left: 10px;
      user-select: none;
    }

    .count {
      position: absolute;
      right: -7px;
      top: -10px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      background: #f5222d;
      color: #fff;
      border-radius: 50%;
      font-size: 12px;
      font-weight: 500;

      i {
        width: 3px;
        height: 3px;
        background: #fff;
        border-radius: 50%;
        margin: 0 1px;
        display: inline-block;
      }
    }

    .msg {
      position: absolute;
      transform: translate(calc(-100% - 25px), -50%);
      line-height: 40px;
      padding: 0 26px;
      height: 40px;
      color: inherit;
      background: #fff;
      box-shadow: inherit;
      border-radius: 20px;

      span {
        min-width: 60px;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 456px;
      }

      &::after {
        border-color: transparent;
        border-right-color: #fff;
        bottom: -9px;
        right: 18px;
      }
    }
  }

  .user {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 300;
    height: 30px;
    margin-right: 30px;
    margin-top: 40px;
    color: #fff;
    i {
      display: inline-block;
      vertical-align: middle;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      margin-right: 10px;
      background: url('https://static-user-center.codemao.cn/user_0005.png') no-repeat center / cover;
    }
    .info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-weight: 400;
      .id {
        font-size: 12px;
        font-weight: 300;
        line-height: 12px;
      }
    }
  }

  .oneMinuteTip {
    display: flex;
  }

  .countdown {
    width: 360px;
    height: 48px;
    display: flex;
    align-items: center;
    position: relative;
    padding-left: 32px;
    margin-top: 36px;
    border-radius: 4px;

    &::after {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      content: '';
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.15);
      z-index: -1;
    }

    .clock {
      display: inline-block;
      width: 19px;
      height: 21px;
      background: url('~images/clock.png')no-repeat center / cover;
      margin-right: 10px;
    }

    .word {
      font-size: 18px;
      color: #fff;
      margin-right: 20px;
      font-weight: 300;
    }

    .time {
      font-size: 32px;
      font-weight: 500;
      color: #fff;
    }
  }
}

.test-content {
  width: 100%;
  height: calc(100% - 110px);
  flex: 1;
  display: flex;
  padding: 0 40px;
  // position: relative;
  z-index: 2;
  margin-top: -157px;
}

.submit-success {
  /deep/ .modal-head {
    border-bottom: none;
  }

  /deep/ .dialog {
    height: 410px;
    background: url('~@/assets/images/exam/submitExam.png') no-repeat center / cover;
  }

  .tip-success {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    color: #fff;
    font-size: 20px;
    font-weight: 500;
    margin-top: 30px;
  }

  .icon-success {
    font-size: 48px;
    margin-bottom: 10px;
  }

  .icon-error {
    font-size: 48px;
    margin-bottom: 10px;
    color: #f5222d;
  }

  .tip-desc {
    margin-top: 100px;
    font-size: 16px;
    color: #333;
    line-height: 22px;
    margin-bottom: 30px;
    font-weight: 400;
    text-align: center;
  }

  .left-btn-wrap {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;

    .confirm {
      @include theme-fill-btn(140px, 42px, 14px, 4px);
    }

    .confirm-tip {
      margin-top: 10px;
      font-size: 12px;
      font-weight: 400;
      color: #5B5B5B;
      line-height: 16px;
    }
  }
}

.submit-tip {
  /deep/ .modal-head {
    border-bottom: none;
  }

  .tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    color: #333;
    font-size: 20px;
    font-weight: 500;
  }

  .icon-right {
    display: inline-block;
    width: 11px;
    height: 9px;
    opacity: 1;
  }

  .icon-sigh {
    display: inline-block;
    width: 5px;
    height: 16px;
    opacity: 1;
  }

  .big-circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-bottom: 10px;
  }

  .small-circle {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    opacity: 1;
  }

  .tip-desc {
    font-size: 16px;
    color: #333;
    line-height: 22px;
    margin-bottom: 30px;
    font-weight: 300;
    text-align: center;
  }

  .submit-btn-wrap {
    width: 100%;
    padding-bottom: 10px;
    display: flex;
    justify-content: center;

    .continue {
      @include theme-fill-btn(112px, 36px, 14px, 4px);
      margin-left: 20px;
    }

    .confirm {
      @include theme-empty-btn(112px, 36px, 14px, 4px)
    }
  }

  .left-btn-wrap {
    width: 100%;
    text-align: center;

    .confirm {
      @include theme-fill-btn(96px, 36px, 14px, 4px);
    }
  }
}

.timeout-tip {
  .tip {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;

    .icon {
      display: inline-block;
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }
  }

  .big-circle {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }

  .small-circle {
    width: 28px;
    height: 28px;
    border-radius: 50%;
  }

  .tip-desc {
    font-size: 16px;
    color: #333;
    line-height: 22px;
    font-weight: 300;
    text-align: center;

    &.red {
      color: #f5222d;
    }
  }
}

.tip-early {
  text-align: center;
  font-size: 16px;
  color: #333;
  line-height: 28px;
  font-weight: 300;

  &.red {
    color: #F5222D;
  }
}

.modal-btn {
  margin: 30px 0 10px 0;
  width: 100%;
  display: flex;
  justify-content: center;

  .continue {
    @include theme-fill-btn(104px, 36px, 14px, 4px);
  }
}

.loading-mask {
  position: fixed;
  top: 100px;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, .4);
  display: flex;
  align-items: center;
  justify-content: center;

  .loading-wrap {
    display: flex;
    flex-direction: column;
    width: 100px;
    height: 100px;
    align-items: center;
    justify-content: center;

    p {
      font-size: 14px;
      margin-top: 20px;
      color: #fff;
    }
  }
}

.total {
  display: inline-block;
  width: 25px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  background: rgba(245, 34, 45, 0.1);
  border-radius: 50%;
  vertical-align: 2px;
  margin: 0 2px;
  color: #F5222DFF;
  font-weight: 600;
}

.back-tip-modal {
  /deep/.modal-head {
    padding: 16px 20px;
    border-bottom: 1px solid #F1F1F1;
  }

  .tip-content {
    margin-bottom: 35px;
  }
}

.camera-monitor {
  position: fixed;
  right: 80px;
  bottom: 107px;
  z-index: 2;
}

.full-camera-monitor {
  right: 120px;
  z-index: -100;
}
</style>

<style lang="scss">
.test-container {
  .btn-wrap {
    width: 100%;
    display: flex;
    justify-content: flex-end;

    .continue {
      @include theme-fill-btn(96px, 36px, 14px, 4px);
      margin-left: 20px;
      margin-bottom: 10px;
    }

    .cancel {
      @include cancel-btn(96px, 36px, 14px, 4px);
    }
  }
}

.before-leave-box /deep/ {
  .el-message-box__content {
    width: 100%;
    padding-top: 50px;
  }

  .el-message-box__btns {
    padding: 40px 0 20px 0;
    display: flex;
    justify-content: flex-end;

    .el-button {
      font-size: 16px;
      margin: 0;
    }

    .confirm-btn {
      margin: 0 20px;
      @include cancel-btn(96px, 36px, 14px, 4px);
      border: 1px solid $themeColor;
      color: $themeColor;
    }

    .cancel-btn {
      @include theme-fill-btn(96px, 36px, 14px, 4px);
      line-height: 1;
    }
  }
}

.save-success-modal {
  /deep/ .dialog {
    text-align: center;

    .content {
      padding: 10px 20px;
    }
  }

  .tip-early {
    margin: 10px 0 25px 0;
  }

  .continue {
    @include theme-fill-btn(96px, 36px, 14px, 4px);
  }

  .success-icon {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    margin: 20px auto auto;
    background: rgba(57, 126, 253, .2) url('~images/success@2x.png') no-repeat center / 28px 28px;
  }
}

.report-modal {
  .tip {
    display: flex;
    margin-top: -15px;
    margin-bottom: 20px;
    font-weight: 300;

    span {
      display: inline-block;
    }

    .title {
      width: 81px;
      margin-right: 12px;
      text-align: right;
      font-weight: 400;
    }

    .text {
      flex: 1;
    }

    a {
      color: $themeColor;
      cursor: pointer;
      font-weight: 400;
    }
  }
}
</style>
